// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.productionTasks_container__tl70M {
  display: flex;
  flex-direction: column;
  align-content: center;
}

.productionTasks_container__header__TZNq7 {
  min-width: 920px;
  padding-top: 20px;
  display: flex;
  justify-content: space-between;
  background: var(--header);
  color: #fff;
  height: 6vh;
}

.productionTasks_btn__hYcwa {
  border-radius: 2px;
  height: 40px;
  width: 9rem;
  font-weight: bold;
  color: #fff;
  border: none;
  font-size: 16px;
  cursor: pointer;
  text-transform: uppercase;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s, color 0.3s, border 0.3s; /* for smooth transition */
}

.productionTasks_btn__yellow__xCJbb {
  background: #e0a900;
}

.productionTasks_btn__yellow__xCJbb:hover {
  color: #e0a900;
  border: 1px solid #e0a900;
  background-color: transparent;
}

.productionTasks_btn__green__kkfEw {
  background: #51b27e;
  color: #fff;
}

.productionTasks_btn__green__kkfEw:hover {
  color: #51b27e;
  border: 1px solid #51b27e;
  background-color: transparent;
}

.productionTasks_container__title__w6NFH {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 150px;
  color: #fff;
  background-color: #075e5b;
}

.productionTasks_title__bWu\\+y {
  font-size: 18px;
  text-align: center;
  font-weight: bold;
  text-transform: uppercase;
}

/* product info */
.productionTasks_container__product__s1aNg {
  padding-top: 0.5rem;
  display: flex;
  flex-direction: row;
}

.productionTasks_container__product_details__-GNEA {
  display: flex;
  flex-direction: column;
  padding-left: 0.5rem;
  /* line-height: 1.1; */
}

.productionTasks_container__product_info__0JitE {
  display: flex;
  flex-direction: row;
  align-items: center;
}

/* .product_details__id {
} */

.productionTasks_product_details__file__PrV7e {
  font-size: 0.7rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 8em;
}

.productionTasks_container__icons__xDMxB {
  padding-left: 0.8rem;
}

.productionTasks_container__input_fields__etqew {
  /* width: 20rem; */
  display: flex;
  flex-direction: row;
}

.productionTasks_pd_top__05__HEcEc {
  padding-top: 0.5rem;
}

.productionTasks_pd_top__2__-Ixvr {
  padding-top: 2rem;
}

.productionTasks_pd__05__Uvn88 {
  padding: 0.5rem;
}

.productionTasks_pd_top__2__-Ixvr {
  padding-top: 2rem;
}

.productionTasks_pd_rg__1__jrWEi {
  padding-right: 1rem;
}

.productionTasks_input_field__separation__XG--r {
  padding-right: 0.5rem;
}

.productionTasks_container_row__60zjI {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.productionTasks_img__preview__Mtlwl {
  border-radius: 4px;
  transition: transform 0.2s;
  margin: auto;
  display: block;
  width: 100%;
}

.productionTasks_img__preview__Mtlwl {
  border-radius: 4px;
  transition: transform 0.2s;
  margin: auto;
  display: block;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/ProductionTasks/productionTasks.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;EACzB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,0DAA0D,EAAE,0BAA0B;AACxF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;GACG;;AAEH;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,YAAY;EACZ,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,YAAY;EACZ,cAAc;EACd,WAAW;AACb","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-content: center;\n}\n\n.container__header {\n  min-width: 920px;\n  padding-top: 20px;\n  display: flex;\n  justify-content: space-between;\n  background: var(--header);\n  color: #fff;\n  height: 6vh;\n}\n\n.btn {\n  border-radius: 2px;\n  height: 40px;\n  width: 9rem;\n  font-weight: bold;\n  color: #fff;\n  border: none;\n  font-size: 16px;\n  cursor: pointer;\n  text-transform: uppercase;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.3s, color 0.3s, border 0.3s; /* for smooth transition */\n}\n\n.btn__yellow {\n  background: #e0a900;\n}\n\n.btn__yellow:hover {\n  color: #e0a900;\n  border: 1px solid #e0a900;\n  background-color: transparent;\n}\n\n.btn__green {\n  background: #51b27e;\n  color: #fff;\n}\n\n.btn__green:hover {\n  color: #51b27e;\n  border: 1px solid #51b27e;\n  background-color: transparent;\n}\n\n.container__title {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 40px;\n  width: 150px;\n  color: #fff;\n  background-color: #075e5b;\n}\n\n.title {\n  font-size: 18px;\n  text-align: center;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n\n/* product info */\n.container__product {\n  padding-top: 0.5rem;\n  display: flex;\n  flex-direction: row;\n}\n\n.container__product_details {\n  display: flex;\n  flex-direction: column;\n  padding-left: 0.5rem;\n  /* line-height: 1.1; */\n}\n\n.container__product_info {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n/* .product_details__id {\n} */\n\n.product_details__file {\n  font-size: 0.7rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 8em;\n}\n\n.container__icons {\n  padding-left: 0.8rem;\n}\n\n.container__input_fields {\n  /* width: 20rem; */\n  display: flex;\n  flex-direction: row;\n}\n\n.pd_top__05 {\n  padding-top: 0.5rem;\n}\n\n.pd_top__2 {\n  padding-top: 2rem;\n}\n\n.pd__05 {\n  padding: 0.5rem;\n}\n\n.pd_top__2 {\n  padding-top: 2rem;\n}\n\n.pd_rg__1 {\n  padding-right: 1rem;\n}\n\n.input_field__separation {\n  padding-right: 0.5rem;\n}\n\n.container_row {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.img__preview {\n  border-radius: 4px;\n  transition: transform 0.2s;\n  margin: auto;\n  display: block;\n  width: 100%;\n}\n\n.img__preview {\n  border-radius: 4px;\n  transition: transform 0.2s;\n  margin: auto;\n  display: block;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `productionTasks_container__tl70M`,
	"container__header": `productionTasks_container__header__TZNq7`,
	"btn": `productionTasks_btn__hYcwa`,
	"btn__yellow": `productionTasks_btn__yellow__xCJbb`,
	"btn__green": `productionTasks_btn__green__kkfEw`,
	"container__title": `productionTasks_container__title__w6NFH`,
	"title": `productionTasks_title__bWu+y`,
	"container__product": `productionTasks_container__product__s1aNg`,
	"container__product_details": `productionTasks_container__product_details__-GNEA`,
	"container__product_info": `productionTasks_container__product_info__0JitE`,
	"product_details__file": `productionTasks_product_details__file__PrV7e`,
	"container__icons": `productionTasks_container__icons__xDMxB`,
	"container__input_fields": `productionTasks_container__input_fields__etqew`,
	"pd_top__05": `productionTasks_pd_top__05__HEcEc`,
	"pd_top__2": `productionTasks_pd_top__2__-Ixvr`,
	"pd__05": `productionTasks_pd__05__Uvn88`,
	"pd_rg__1": `productionTasks_pd_rg__1__jrWEi`,
	"input_field__separation": `productionTasks_input_field__separation__XG--r`,
	"container_row": `productionTasks_container_row__60zjI`,
	"img__preview": `productionTasks_img__preview__Mtlwl`
};
export default ___CSS_LOADER_EXPORT___;
